const dataLayerEventHelper = (eventName, query, getData) => {
  const clickHandler = el => event => {
    const data = getData(el, event);
    if (data) {
      dataLayer.push(data);
    }
  };

  document.querySelectorAll(query).forEach(
    el => el.addEventListener(eventName, clickHandler(el))
  );
};

dataLayerEventHelper('click', 'a[data-social-kind]', el => ({
  event: 'social click',
  eventName: 'social_click',
  platform_name: el.dataset.socialKind,
  eventCategory: 'Socials | Ext. LinkClick',
  eventAction: el.dataset.socialKind,
  eventLabel: '""',
}));

dataLayerEventHelper('click', 'a[href$=".pdf"]', el => ({
  eventName: 'pdf_download',
  pdf_name: el.href,
  eventCategory: 'Download',
  eventAction: 'PDF Download',
  eventLabel: el.href,
}));

dataLayerEventHelper('click', 'a[href^="tel:"]', el => ({
  eventName: 'contact',
  contact_action: 'call_to',
  eventCategory: 'Call to',
  eventAction: 'LinkClick',
  eventLabel: '""',
}));
